import { scrollActionTypes } from '@constants/actionTypes/ssapActionTypes';

export const INITIAL_STATE = null;

export default (state = INITIAL_STATE, action = {}) => {
    switch(action.type) {
        case scrollActionTypes.DEFINE_ELEMENT_FOR_SCROLLING:
            if(typeof action.element !== 'string') {
                throw new Error('Not a string has been passed to scrollReducer');
            }
            return action.element;
        case scrollActionTypes.CLEAR_ELEMENT_FOR_SCROLLING:
            return INITIAL_STATE;
        case scrollActionTypes.CLEAR_SSAP_STATE:
            return INITIAL_STATE;
        default:
            return state;
    }
};
